'use strict';
var _ = require('lodash');
var Constants = require('../constants/YourDetailsConstants');
var ApplicationConstants = require('../constants/ApplicationConstants');
var AuNumbers = Constants.AU_numbers;
var SofOT = ApplicationConstants.SofSowOther.SOFOT;
var SowOT = ApplicationConstants.SofSowOther.SOWOT;

module.exports = {
    removeError: function (errorList, fieldId) {
        if (errorList.length > 0) {
            _.remove(errorList, function (o) { return !o ? null : o.id === fieldId });
        }
    },

    removeSpaces: function (value) {
        return value.replace(/ /g, '');
    },

    removeCommas: function (val) {
        return (typeof val === 'string') ? val.replace(/,/g, '') : val;
    },

    strStartsWith: function (string, prefix) {
        return string.indexOf(prefix) === 0;
    },

    strEndsWith: function (string, suffix) {
        return string.indexOf(suffix, string.length - suffix.length) !== -1;
    },

    currencyFormat: function (value, decorate) {
        value = (typeof value === 'string') ? value.replace(/,/g, '') : value;
        var amt = parseFloat(value);
        var num = new Number(amt);
        var mask = num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        var decorated = decorate ? ('$' + mask) : mask;
        return decorated;
    },
    currencyUnformat: function (value) {
        if (value !== 0) {
            value = value.replace(/[^0-9-.]/g, '');
        }
        var amt = parseFloat(value).toFixed(2);
        return amt;
    },

    formatString: function (str, args) {
        if (!str) {
            return '';
        }

        return str.replace(/{{(\w+)}}/g, function (match, word) {
            return args[word] || '';
        });
    },

    formatFullname: function (title, givenName, lastName) {
        return (title ? (title + ' ') : '') +
            (givenName ? (givenName + ' ') : '') +
            (lastName ? (lastName) : '');
    },

    formatClientDisplayName: function (givenName, lastName, status) {
        return (lastName ? lastName : '') +
        (lastName && givenName ? ', ' : '') +
        (givenName ? givenName : '') +
        ((lastName || givenName) && status ? ' ' : '') +
        (status ? '(' + status +')' : '');
    },

    findCountry: function (countryCode, countryList) {
        return _.trim(_.get(_.find(countryList,
            function (o) { return _.trim(o.value).toLowerCase() === _.trim(countryCode).toLowerCase(); }),
            'label',
            ''));
    },

    formatAddress: function (address1, address2, cityStatePostCode, state, postCode, country, countryList) {
        const countryName = country && country.toUpperCase() !== 'AU' ? this.findCountry(country, countryList) : '',
            addressLine = (address1 ? address1 : '') + (address2 ? (address1 ? ' ' + address2 : address2) : ''),
            seperator = ', ',
            ausState = (typeof state !== 'undefined') ? (seperator + state.toUpperCase()) : '',
            ausPostCode = (typeof postCode !== 'undefined') ? (seperator + postCode) : '',
            ausStatePostcode = ausState + ausPostCode;

        const intPostcode = (country && country.toUpperCase() === 'AU') ? ausStatePostcode : '';
        return (addressLine ? addressLine : '') +
            (cityStatePostCode ? (seperator + cityStatePostCode.toUpperCase()) : '') +
            intPostcode +
            (countryName ? (seperator + countryName) : '');
    },

    formatResidentialAddress: function (address, countryList) {
        if (!address) {
            return '';
        }

        if (address.address && address.isResAddressFound) {
            return address.address;
        }

        return this.formatAddress(
            address.address1,
            address.address2,
            address.cityStatePostCode,
            address.australiaState,
            address.postCode,
            address.country,
            countryList
        );
    },

    formatPostalAddress: function (address, countryList) {
        if (!address) {
            return '';
        }

        if (address.address && address.isPostalAddressFound) {
            return address.address;
        }

        if (address.isSameAsResidentialAddress === 'Y') {
            return 'Same as residential address';
        } else {
            return this.formatAddress(
                address.address1,
                address.address2,
                address.cityStatePostCode,
                address.australiaState,
                address.postCode,
                address.country,
                countryList
            );
        }
    },

    formatPhone: function (phone) {
        // landline
        if (phone && (this.strStartsWith(phone, AuNumbers.Start_02) || this.strStartsWith(phone, AuNumbers.Start_03) ||
            this.strStartsWith(phone, AuNumbers.Start_07) || this.strStartsWith(phone, AuNumbers.Start_08))) {
            return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2 $3');
        }

        // mobile
        if (phone && (this.strStartsWith(phone, AuNumbers.Start_04) || this.strStartsWith(phone, AuNumbers.Start_05))) {
            return phone.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
        }

        return phone;
    },

    /*
    The system does not perform any rounding on the value entered by the user.
    eg: 10.999 = 10.99 not 11.00
    eg: 10.899 = 10.89 not 10.90
    */
    currencyFormatWithoutRounding: function (value) {
        var hasCents,
            oneAmount,
            centAmount = '',
            centDigits = '',
            formatted;

        value = (typeof value === 'string') ? value.replace(/,/g, '') : value;

        value = value.toString();

        //check and remove if char start zero.
        while (value.charAt(0) === '0') {
            value = value.slice(1);
        }

        hasCents = value.indexOf('.') > -1;

        if (hasCents) {
            var num = value.split('.');
            oneAmount = num[0];
            centAmount = num[1];

            if (oneAmount.length === 0) {
                value = '0' + value;
            }

            if (centAmount.length === 0) {
                centDigits = '00';
            } else if ((centAmount.length > 0) && (centAmount.length < 2)) {
                centDigits = '0';
            }

        } else {
            centDigits = (!value) ? '0.00' : '.00';
        }

        value = (centDigits) ? value += centDigits : value;

        if (centAmount.length <= 2) {
            formatted = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        } else {
            formatted = oneAmount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + '.' + centAmount;
        }

        return formatted;
    },

    //Branch number is a numeric value
    //Must be equal to 6 char.
    formatBranchNumber: function (value) {
        return value.replace(/(\d{3})(\d{3})/, '$1-$2');
    },

    maskMobileNumber: function(mobileNumber) {
        if (mobileNumber && (this.strStartsWith(mobileNumber, AuNumbers.Start_04) || this.strStartsWith(mobileNumber, AuNumbers.Start_05))) {
            return 'XXX XXXX ' + mobileNumber.slice(-3);
        }
        return '';
    },

    mask: function(str, maskChar) {
        if (!maskChar) {
            maskChar = '*';
        }
        var mask = '';
        if (str){
            _.times(str.length, function() {
                mask += maskChar;
            });
        }
        return mask;
    },

    hasHtmlHeading: function(str){
        return /<[hH][1-6]>/.test(str);
    },

    formatAccountNumber: function(value){
        if (value && value.length === 13){
            return value.substr(1, 4) + ' ' + value.substr(5, 4) + ' ' + value.substr(9, 4)    
        }
        return value;
    },

    addClickCallbackToLink: function(id, callBack){
        let link = document.getElementById(id)
        if (link){
            link.addEventListener('click', callBack);
            return true;
        }
        return false;
    },

    removeClickCallback: function(id, callBack){
        let link = document.getElementById(id)
        if (link){
            link.removeEventListener('click', callBack);
            return true;
        }
        return false;
    },

    roundToTwo: function (num) {
        if (num) {
            return parseFloat(+(Math.round(num + 'e+2') + 'e-2'));
        }
        return num;
    },
    findSofSow: function (SelectedValue, list) {
        if (SelectedValue === undefined || SelectedValue === null) {
            return '';
        }
        var selectedCodeList = SelectedValue.split(',')
        var selectedText = '';

        for (var selectedCode in selectedCodeList) {
            if (selectedCodeList[selectedCode] != SofOT && selectedCodeList[selectedCode] != SowOT) {
                selectedText += _.trim(_.get(_.find(list,
                    function (o) { return _.trim(o.value).toLowerCase() === _.trim(selectedCodeList[selectedCode]).toLowerCase(); }),
                    'label',
                    ''));
                selectedText += ', ';
            }
        }
        return selectedText.replace(/,\s*$/, '');
    }
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/Formatter.js